"use client";
import SectionHeader from "@/components/common/section-header";
import useInViewPort from "@/hooks/useInViewport";
import Image from "next/image";
import { FC, ReactNode, useEffect, useState } from "react";
import WeAreImg from "@/../public/images/abstract/values/WE-ARE.png";
import MissionImg from "@/../public/images/abstract/values/MISSION.png";
import VisionImg from "@/../public/images/abstract/values/VISION.png";
import Highlight from "@/components/common/highlight";
import { doItEN } from "@/assets/dictionaries/en/about-content";
import { doItES } from "@/assets/dictionaries/es/about-content";

const Card: FC<{
  children: ReactNode;
  title: string;
  image: ReactNode;
  extendedStyle: string;
}> = ({ children, title, image, extendedStyle }) => {
  const { ref, isInViewport } = useInViewPort<HTMLDivElement>({ once: true });

  return (
    <article
      className={`p-8 rounded-md min-w-60 drop-shadow-lg flex flex-col flex-1 gap-4 justify-between items-center  ${extendedStyle} ${isInViewport ? "animate-fadein" : "opacity-0"}`}
      ref={ref}
    >
      <div className="flex flex-col gap-4 lg:min-h-[250px]">
        <h3 className="text-3xl px-2 font-bold text-center">{title}</h3>
        <p className="text-xl text-left">{children}</p>
      </div>
      <div className="mt-2 relative w-[80px] h-[80px] flex justify-center">
        {image}
      </div>
    </article>
  );
};

const DoItRightFast: FC = () => {
  const [doItContent, setDoItContent] = useState(doItEN); // Default to English

  useEffect(() => {
    // Get the language from localStorage
    const lang = localStorage.getItem("selectedOption") || "EN"; // Default to EN if not found

    // Set the content based on the language
    switch (lang.toUpperCase()) {
      case "ES":
        setDoItContent(doItES);
        break;
      case "EN":
      default:
        setDoItContent(doItEN);
        break;
    }
  }, []);
  return (
    <section className="px-page-xl py-16">
      <SectionHeader>
        <div className="max-w-[240px] md:max-w-none">
          {doItContent.title_section}
        </div>
      </SectionHeader>

      <div className="flex mt-8 gap-8 flex-wrap">
        <Card
          extendedStyle="bg-gradient-to-br from-slate-900 to-gbci-primary text-white"
          title={doItContent.we_are_title}
          image={<Image src={WeAreImg} alt="" />}
        >
          {doItContent.we_are_desc_1_1}{" "}
          <span className="font-bold">{doItContent.we_are_desc_1_2}</span>
        </Card>
        <Card
          extendedStyle="bg-gradient-to-br from-white to-slate-100"
          title={doItContent.our_mission_title}
          image={<Image src={MissionImg} alt="" />}
        >
          {doItContent.our_mission_desc}
        </Card>
        <Card
          extendedStyle="bg-gradient-to-br from-gbci-primary to-gbci-accent text-white"
          title={doItContent.our_vision_title}
          image={<Image src={VisionImg} alt="" />}
        >
          {doItContent.our_vision_desc}
        </Card>
      </div>
    </section>
  );
};

export default DoItRightFast;
